import { Field, useFormikContext } from 'formik';
import styles from './TemplateFormSSLConfigField.module.scss';
import { FormikSwitchWrapper } from '../../../switch/FormikSwitchWrapper';
import { FormControl } from '../../../shared/components/FormControl/FormControl';
import { FormikFileInputField } from '../../../input/FormikFileInputField/FormikFileInputField';
import { TemplateFormFieldProps } from '../../interfaces/template-form';
import { FileData } from '../../../shared/interfaces/file';
import { TemplateFormSslConfigFieldMeta } from './interfaces/template-form-ssl-config-field-meta';

export function TemplateFormSSLConfigField({
  field,
  metadata,
  formDisabled
}: TemplateFormFieldProps) {
  const props = metadata as TemplateFormSslConfigFieldMeta;

  const formikProps = useFormikContext<{
    ssl_client_key: FileData;
    ssl_client_cert_file: FileData;
    ssl_ca_file: FileData;
  }>();

  const renderSSLFields = !!field.value;
  const disableSSL = props.disabled || formDisabled;

  return (
    <div>
      <FormikSwitchWrapper
        dataId='ssl'
        fieldName={field.name}
        label='Use SSL'
        disabled={disableSSL}
        switchProps={{ disabled: disableSSL }}
      >
        Connect over an SSL-encrypted connection
      </FormikSwitchWrapper>

      {renderSSLFields ? (
        <div className={styles.sslConfigFieldsContainer}>
          <FormControl className={styles.sshConfigField}>
            <Field
              name='ssl_ca_file'
              label='CA File'
              component={FormikFileInputField}
              disabled={disableSSL}
              accept='.pem,.txt'
              required
              onChangeEventHandler={async (file: FileData | null) => {
                const content = file ? file.content : null;
                await formikProps.setFieldValue('ssl_ca_file', content);
              }}
            />
          </FormControl>

          <FormControl className={styles.sshConfigField}>
            <Field
              name='ssl_client_cert_file'
              label='Client Certificate'
              component={FormikFileInputField}
              required={renderSSLFields && !!formikProps.values.ssl_client_key}
              disabled={disableSSL}
              onChangeEventHandler={async (file: FileData | null) => {
                const content = file ? file.content : null;
                await formikProps.setFieldValue('ssl_client_cert_file', content);
              }}
            />
          </FormControl>

          <FormControl className={styles.sshConfigField}>
            <Field
              name='ssl_client_key'
              label='Client Key'
              required={renderSSLFields && !!formikProps.values.ssl_client_cert_file}
              component={FormikFileInputField}
              disabled={disableSSL}
              onChangeEventHandler={async (file: FileData | null) => {
                const content = file ? file.content : null;
                await formikProps.setFieldValue('ssl_client_key', content);
              }}
            />
          </FormControl>
        </div>
      ) : null}
    </div>
  );
}
